// Class: lime.utils.BytePointerData

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var BytePointerData = function(bytes,offset) {
	this.bytes = bytes;
	this.offset = offset;
}

// Meta

BytePointerData.__name__ = "lime.utils.BytePointerData";
BytePointerData.__isInterface__ = false;
BytePointerData.prototype = {
	
};
BytePointerData.prototype.__class__ = BytePointerData.prototype.constructor = $hxClasses["lime.utils.BytePointerData"] = BytePointerData;

// Init



// Statics




// Export

exports.default = BytePointerData;